<script setup lang="ts">
const route = useRoute();
const slug = computed(() => (route.params.slug as string) || "");

useHead({
  title: "Donate",
});

const { data: page } = await useAsyncData(() =>
  useDirectus(
    readItems("causes", {
      fields: ["*"],
      filter: {
        status: { _eq: "published" },
        slug: { _eq: slug.value },
      },
    })
  ).then((results) => (results.length ? results[0] : null))
);
if (!page.value) {
  throw createError({ statusCode: 404, fatal: true });
}
</script>

<template>
  <div v-if="!!page">
    <CommonPageBanner
      :image="page?.banner_image ? page.banner_image : '/page-banner.jpg'"
      :local-asset="page?.banner_image ? false : true"
      size="small"
    >
      <h1 class="text-4xl font-semibold md:text-6xl xl:text-banner">
        {{ page.name }}
      </h1>
    </CommonPageBanner>

    <CommonContainer class="py-[--y-margin]">
      <div class="mx-auto flex max-w-[1440px] flex-col items-start gap-8 md:gap-14 lg:flex-row xl:gap-28">
        <Wysiwyg :content="page.content || ''" class="xl:max-w-[50%]" />
        <Wysiwyg
          v-if="page.is_external_form"
          :content="page.donation_form || ''"
          external-script="https://cdn.raisely.com/v3/public/embed.js"
          class="xl:grow"
        />
        <DonationWidget v-else :stripe-id="page.stripe_id || undefined" :slug="page.slug || ''" />
      </div>
    </CommonContainer>
  </div>
</template>
